import { colors } from '@web-for-marketing/react-ui';
import { FooterBackground } from '@models/footer';

export const footerBackgroundColors = {
    [FooterBackground.DarkBlue]: colors.core.deepSpace,
    [FooterBackground.Black]: '#000000',
};
